import auth from './auth'
import filter from './filter'
import monthlyDashboard from './monthlyDashboard';
const model = {
  auth,
  filter,
  monthlyDashboard
}

export default model
